<template>
  <div class="tag-cloud clearfix">
    <router-link
      v-for="tag in tags.slice(0, 5)"
      :key="tag.id"
      :to="{ name: SEARCH_PAGE_NAME, query: { tags: [tag.id] } }"
      class="tag"
    >
      {{ tag.name }}
    </router-link>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import { SEARCH_PAGE_NAME } from "@/router/pageNameConstants";

export default {
  computed: {
    ...mapGetters("tags", {
      tags: "getAll"
    })
  },
  data() {
    return {
      SEARCH_PAGE_NAME
    };
  }
};
</script>
